<p-inputNumber
  #inputNumberRef
  [(ngModel)]="value"
  (ngModelChange)="selectValue($event)"
  [showButtons]="true"
  buttonLayout="horizontal"
  [min]="min"
  [max]="max"
  [suffix]="weeksSuffix"
  inputId="horizontal"
  incrementButtonIcon="pi pi-plus"
  decrementButtonIcon="pi pi-minus"
  mode="decimal"
  [attr.data-qa]="'cardContainer_inputNumber'"
  [ngClass]="{ 'left-button--disabled': value === min, 'right-button--disabled': value === max || rightButtonDisabled }"
  styleClass="weeks-counter__input-number"
/>
